const MAX_COLS = 7;
const COLS_MIDDLE = Math.floor(MAX_COLS / 2);

function transformInstructions(categories, letters, vowels, c_words, q_words) {
  const newVowels = transformVowels(vowels);
  const { leftCategoryLetters, acc } = createLeftCategoryLetterCell(c_words, letters[0], newVowels);
  const rightCategoryLetters = createRightCategoryLetterCell(q_words, letters[1], acc);
  const targetCell = createTargetCell(letters[0]);

  return { targetCell, categories, vowels: newVowels, leftCategoryLetters, rightCategoryLetters };
}

function createTargetCell(letter) {
  return { ...letter, id: 0, row_index: 1, column_index: COLS_MIDDLE };
}

function transformVowels(vowels) {
  return vowels.map((letter, index, arr) => ({
    id: index + 1,
    letter,
    row_index: arr.length > 1 ? index : 1,
    column_index: COLS_MIDDLE,
  }));
}

function createLeftCategoryLetterCell(words, target, vowels) {
  if (target.letter === vowels[0].letter) {
    return words.reduce((prev, word) => {
      const targetIndex = word.indexOf(target.letter);
      const newLeftCategoryLetter = { ...prev };
      if (!newLeftCategoryLetter.leftCategoryLetters[target.letter]) {
        newLeftCategoryLetter.leftCategoryLetters[target.letter] = [];
      }
      newLeftCategoryLetter.leftCategoryLetters[target.letter].push(
        createLeftCategoryLetterAsVowel(word, vowels[0].letter, targetIndex),
      );
      newLeftCategoryLetter.acc = prev.acc + word.length - 2;
      return newLeftCategoryLetter;
    }, { leftCategoryLetters: {}, acc: 0 });
  }

  const startingId = vowels.length + 1;
  return words.reduce((prev, word) => {
    const newLeftCategoryLetter = { ...prev };
    const targetIndex = word.indexOf(target.letter);
    const nextLetter = word.charAt(targetIndex + 1);
    if (!newLeftCategoryLetter.leftCategoryLetters[nextLetter]) {
      newLeftCategoryLetter.leftCategoryLetters[nextLetter] = [];
    }
    newLeftCategoryLetter.leftCategoryLetters[nextLetter].push(
      createLeftCategoryLetterSingleCell(word, targetIndex, prev.acc, vowels),
    );
    newLeftCategoryLetter.acc = prev.acc + word.length - 2;
    return newLeftCategoryLetter;
  }, { leftCategoryLetters: {}, acc: startingId });
}

function createLeftCategoryLetterAsVowel(word, vowel, targetIndex) {
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  const splittedWord = word.split('');
  return {
    column_index: startPosition,
    vowel,
    word,
    cells: splittedWord.map((letter, index) => ({
      id: targetIndex + index,
      letter,
      row_index: 1,
      column_index: startPosition + index - 1,
    })),
  };
}

function createLeftCategoryLetterSingleCell(word, targetIndex, id, vowels) {
  const targetVowel = word.charAt(targetIndex + 1);
  const vowel = vowels.find(v => v.letter === targetVowel);
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  let splittedWord = word.split('').slice(targetIndex + 2);
  let initialLetters = [];
  if (targetIndex > 0) {
    initialLetters = word.split('').slice(0, targetIndex);
    splittedWord = [...initialLetters, ...splittedWord];
  }
  return {
    column_index: startPosition + initialLetters.length,
    vowel: targetVowel,
    word,
    cells: splittedWord.map((letter, index) => {
      let column_index;
      if (initialLetters.length > index) {
        column_index = startPosition - initialLetters.length + index;
      } else {
        column_index = initialLetters.length + index + startPosition + 1;
      }
      return {
        id: id + index,
        letter,
        row_index: vowel.row_index,
        column_index,
      };
    }),
  };
}

function createRightCategoryLetterCell(words, target, startingId) {
  const { rightCategoryLetterCell } = words.reduce((prev, word) => {
    const newRightCategoryLetterCell = { ...prev };
    const targetIndex = word.indexOf(target.letter);
    newRightCategoryLetterCell.rightCategoryLetterCell.push({
      cells: createRightCategoryLetterSingleCell(word, targetIndex, newRightCategoryLetterCell.acc),
    });
    newRightCategoryLetterCell.acc += word.length;
    return newRightCategoryLetterCell;
  }, { rightCategoryLetterCell: [], acc: startingId });
  return rightCategoryLetterCell;
}

function createRightCategoryLetterSingleCell(word, targetIndex, id) {
  const startPosition = getPositionFromLength(word.length, MAX_COLS);
  const splittedWord = word.split('').slice(targetIndex + 1);

  return splittedWord.map((letter, index) => ({
    id: id + index,
    letter,
    row_index: 1,
    column_index: startPosition + index,
  }));
}

function getPositionFromLength(length, maxLength) {
  const shift = length % 2 === 0 ? 2 : 1;
  return Math.floor(maxLength / 2) - Math.floor(length / 2) + shift;
}
export default transformInstructions;
